import { type FC } from 'react';

import { SuggestionAttribute, type SuggestionSource } from '@zen/graphql/types.generated';

import { extractProposedText } from './helpers';
import { SuggestionPill } from './SuggestionPill/SuggestionPill';
import { SuggestionText } from './SuggestionText/SuggestionText';

interface SuggestionProps {
  id: string;
  isLoading: boolean;
  onAccept: (id: string) => void;
  onReject: (id: string, reason: string) => void;
  proposedValue: string;
  sources: SuggestionSource[];
  targetAttribute: SuggestionAttribute;
  variant: 'pill' | 'text';
}

const Suggestion: FC<SuggestionProps> = (props) => {
  const { proposedValue, targetAttribute, id, isLoading, onAccept, onReject, variant, sources } = props;
  const proposedValueText = extractProposedText(proposedValue, targetAttribute);

  if (variant === 'pill')
    return (
      <SuggestionPill
        id={id}
        isLoading={isLoading}
        onAccept={onAccept}
        onReject={onReject}
        proposedValueText={proposedValueText}
        source={sources[0]}
      />
    );

  if (variant === 'text')
    return (
      <SuggestionText
        id={id}
        isLoading={isLoading}
        onAccept={onAccept}
        onReject={onReject}
        proposedValueText={proposedValueText}
      />
    );
};

export default Suggestion;
